import { Injectable } from '@angular/core';
import { ChatMessage, ChatMessageRole, ChatMessageType } from '../../models/ai-insights/chat-message';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AiInsightsMessageParserService {

  constructor(private translate: TranslateService) {
  }

  parseChatMessage(text: string, role: ChatMessageRole): ChatMessage[] {
    const messages: ChatMessage[] = [];
    const regex = /```(md|chart)\n([\s\S]*?)\n```/g;
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
      // Add the text before the code block
      if (match.index > lastIndex) {
        messages.push({
          type: ChatMessageType.TEXT,
          content: text.substring(lastIndex, match.index).trim(),
          role: role,
        });
      }

      const type = match[1] as ChatMessageType.MARKDOWN | ChatMessageType.CHART;
      const content = match[2].trim();

      if (type === ChatMessageType.CHART) {
        try {
          messages.push({
            type: ChatMessageType.CHART,
            content: JSON.parse(content),
            role: role,
          });
        } catch (e) {
          console.error('Error parsing chart JSON:', e);
          messages.push({
            type: ChatMessageType.TEXT,
            content: this.translate.instant('AI_INSIGHTS.CHART_PARSE_ERROR'),
            role: ChatMessageRole.SYSTEM,
          });
        }
      } else {
        messages.push({
          type: ChatMessageType.MARKDOWN,
          content: content,
          role: role,
        });
      }

      lastIndex = regex.lastIndex;
    }

    // Add any remaining text after the last code block
    if (lastIndex < text?.length) {
      messages.push({
        type: ChatMessageType.TEXT,
        content: text.substring(lastIndex).trim(),
        role: role,
      });
    }

    return messages.filter(m => m.content);
  }
}
